import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import About from "./components/About";
import Services from "./components/Services";
import Gallery from "./components/Gallery";
import SocialMedia from "./components/SocialMedia";
import FAQ from "./components/FAQ";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen font-sans">
      <Navbar />
      <Hero />
      <About />
      <Services />
      <Gallery />
      <SocialMedia />
      <FAQ />
      <Contact />
      <Footer />

      {/* WhatsApp Floating Button */}
      <a
        href="https://wa.me/34642885747?text=Hola%2C%20me%20gustar%C3%ADa%20solicitar%20un%20presupuesto%20para%20mi%20piscina."
        target="_blank"
        rel="nofollow noreferrer"
        className="fixed bottom-6 right-6 z-50 bg-green-500 hover:bg-green-600 text-white rounded-full shadow-lg shadow-green-500/40 flex items-center gap-2 px-4 py-3 transition-all hover:scale-105 cursor-pointer"
        aria-label="Escríbenos por WhatsApp"
      >
        <div className="w-6 h-6 flex items-center justify-center">
          <i className="ri-whatsapp-line text-xl"></i>
        </div>
        <span className="text-sm font-semibold whitespace-nowrap hidden sm:inline">Escríbenos por WhatsApp</span>
      </a>
    </div>
  );
}
